// extracted by mini-css-extract-plugin
export default {"label":"InputLabel_label__TNC1Q","asterisk":"InputLabel_asterisk__HeNHL","errorText":"InputLabel_errorText__+q538","optionaText":"InputLabel_optionaText__zPZDz"};